<template>
    <div>

        <PageHeader side-class="flex-shrink-0">
            <div>{{ node.name }}</div>
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonIcon icon="plus" :disabled="!node.id" @click="showModalAddCategoryToGroup()">{{ $t('addToGroup') }}</ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <div class="mb-3">
            <div><strong>ID:</strong> {{ node.id }}</div>
        </div>

        <StatsWidgets />

        <TrafficChart />

        <SalesChart />

        <ModalAddItemToGroup />

    </div>
</template>



<script>
    import StatsWidgets from './StatsWidgets.vue';
    import TrafficChart from './TrafficChart.vue';
    import SalesChart from './SalesChart.vue';
    import ModalAddItemToGroup from './ModalAddItemToGroup.vue';

    export default {
        name: 'CategoryStats',
        components: {
            StatsWidgets,
            TrafficChart,
            SalesChart,
            ModalAddItemToGroup,
        },
        props: {
            node: {
                type: Object,
                required: true,
            },
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestSalesStats: this.$req('producerProductCategory/salesStats'),
                requestClicksStats: this.$req('producerProductCategory/clicksStats'),
                requestImpressionsStats: this.$req('producerProductCategory/impressionsStats'),
                requestTrafficChart: this.$req('producerProductCategory/trafficChart'),
                requestSalesChart: this.$req('producerProductCategory/salesChart'),
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
        },
        methods: {
            showModalAddCategoryToGroup() {
                this.$root.$emit('bv::show::modal', 'modal-add-item-to-group');
                this.$root.$emit('modal-add-item-to-group', this.node);
            },
        },
    };
</script>
